module.exports = __webpack_public_path__ + "img/empty.2e862aec.png";